module.exports = __webpack_public_path__ + "static/WorkSans-Regular-1dc37d04c91ff4bb213e90615873e708.woff2";